/**
 * Route guards. RequireProfile replaces the hard window.location redirect
 * the old Layout did on every page; RequireAdmin keeps the exact "Access
 * denied" text the admin pages used to render themselves.
 */

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

import { useAuth } from './AuthContext';
import { loginUrl } from './loginUrl';

export function Spinner() {
  return (
    <div className="flex justify-center items-center min-h-[70vh]">
      <Loader2 className="h-8 w-8 animate-spin text-indigo-400" />
    </div>
  );
}

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <Spinner />;
  if (status === 'anon') return <Navigate to={loginUrl(location.pathname + location.search)} replace />;
  return <Outlet />;
}

export function RequireAdmin() {
  const { status, user } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <Spinner />;
  if (status === 'anon') return <Navigate to={loginUrl(location.pathname + location.search)} replace />;
  if (user?.role !== 'admin') {
    return <div className="flex items-center justify-center min-h-[70vh] text-gray-500">Access denied. Admin accounts only.</div>;
  }
  return <Outlet />;
}

const PROFILE_EXEMPT = new Set(['/CompleteProfile', '/Login', '/SignUp', '/VerifyEmail', '/ForgotPassword', '/ResetPassword', '/SetPassword']);

export function RequireProfile() {
  const { status, user } = useAuth();
  const location = useLocation();
  if (status === 'authed' && user && !user.profile_complete && !PROFILE_EXEMPT.has(location.pathname)) {
    return <Navigate to={`/CompleteProfile?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }
  return <Outlet />;
}
